import { Component, OnInit } from "@angular/core";
import { DataElement } from "src/app/shared/models/common";
import {
  REPORTS_SCREEN_TYPE_ENUM,
  InvoiceReportsSearchParams,
} from "src/app/shared/models/invoices.model";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { keyCodes } from "src/app/shared/models/key-codes.model";
import { AuthService } from "src/app/shared/services/auth.service";
import { Store } from "@ngrx/store";
import {
  clinicList,
  curTotalDept,
  currentReportScreenType,
  reportsSearchParams,
} from "src/app/shared/ngrx/ngrx-selectors";
import {
  CLEAR_REPORTS_SEARCH,
  RUN_REPORTS_SEARCH,
  SELECT_REPORT_SCREEN_TYPE,
} from "src/app/shared/ngrx/ngrx-actions";
import { DatePickerModule } from "primeng/datepicker";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { InputWrapComponent } from "src/app/shared/components/ui/input-wrap.component";
import { SelectModule } from "primeng/select";
import { TooltipDirective } from "src/app/shared/components/ui/tooltip.directive";

@Component({
  selector: "report-filters",
  templateUrl: "./report-filters.component.html",
  styleUrls: ["./report-filters.component.scss"],
  imports: [
    CommonModule,
    FormsModule,
    InputWrapComponent,
    TranslateModule,
    DatePickerModule,
    SelectModule,
    TooltipDirective,
  ],
  standalone: true,
})
export class ReportFiltersComponent implements OnInit {
  selectedClinic: DataElement;
  fromDate: Date;
  toDate: Date;
  documentId: number;
  calLocale = {};
  reportTypes: DataElement[] = [];
  displayClinicFields: boolean;
  searchParams: InvoiceReportsSearchParams = {};

  get currentTotalDept(): number {
    return this.store.selectSignal(curTotalDept)();
  }

  get clinicList(): DataElement[] {
    return this.store.selectSignal(clinicList)();
  }

  get dispayedClinic(): DataElement {
    return this.store.selectSignal(reportsSearchParams)()?.clinic;
  }

  get documentIdPlaceholder(): string {
    switch (this.store.selectSignal(currentReportScreenType)()) {
      case REPORTS_SCREEN_TYPE_ENUM.INVOICES:
        return "translate.general.invId";
      case REPORTS_SCREEN_TYPE_ENUM.RECEIPTS:
        return "translate.general.rcptId";
      case REPORTS_SCREEN_TYPE_ENUM.BALANCE:
        return "translate.general.documentId";
      default:
        return "";
    }
  }

  constructor(
    private readonly store: Store,
    private translateService: TranslateService,
    private authService: AuthService
  ) {
    this.displayClinicFields = this.authService.currentUser.org == "LAB";

    this.translateService.get("calLocale").subscribe((data) => {
      this.calLocale = data;
    });

    let t1 = new DataElement(
      REPORTS_SCREEN_TYPE_ENUM.INVOICES,
      "translate.reports.invoices"
    );
    let t2 = new DataElement(
      REPORTS_SCREEN_TYPE_ENUM.RECEIPTS,
      "translate.reports.receipts"
    );
    let t3 = new DataElement(
      REPORTS_SCREEN_TYPE_ENUM.BALANCE,
      "translate.reports.balance"
    );
    this.reportTypes.push(t1, t2, t3);
  }

  ngOnInit(): void {
    if (this.clinicList.length == 1) {
      this.selectedClinic = this.clinicList[0];
    }
  }

  ngAfterViewInit(): void {
    this.search();
  }

  selectReportType(type: DataElement) {
    this.store.dispatch(SELECT_REPORT_SCREEN_TYPE({ screenType: type.id }));
  }

  isSelected(type: DataElement): boolean {
    return this.store.selectSignal(currentReportScreenType)() == type.id;
  }

  search() {
    if (!this.allowedSubmit()) return;
    this.runSearch();
  }

  runSearch() {
    this.searchParams.clinic = this.selectedClinic;
    this.searchParams.documentId = this.documentId;
    this.searchParams.fromDate = this.fromDate;
    this.searchParams.toDate = this.toDate;

    this.store.dispatch(
      RUN_REPORTS_SEARCH({ searchParams: this.searchParams })
    );
  }

  clearSearch() {
    if (this.clinicList.length == 1) {
      this.selectedClinic = this.clinicList[0];
    } else {
      this.selectedClinic = null;
    }

    this.documentId = null;
    this.fromDate = null;
    this.toDate = null;

    if (!this.allowedSubmit()) {
      this.store.dispatch(CLEAR_REPORTS_SEARCH());
    } else {
      this.search();
    }
  }

  allowedSubmit(): boolean {
    return true;
    //return this.selectedClinic != null;
  }

  getValidationTooltip(): string {
    if (!this.allowedSubmit())
      return this.translateService.instant("translate.reports.validateClinic");
    else return " ";
  }

  onKeyPress(e: any) {
    if (e.keyCode == keyCodes.enter) {
      this.search();
    }
  }

  onFieldValueChanged(e: any) {
    this.search();
  }
}
